/**
 * TanStack Query hooks for `igaming-ngr-ggr`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingNgrGgrQueryKeys,
	type CreateIgamingNgrGgrBody,
	type ListIgamingNgrGgrResponse,
	type IgamingNgrGgrRow,
} from "./api";

export function useIgamingNgrGgrList(): UseQueryResult<ListIgamingNgrGgrResponse, Error> {
	return useQuery({
		queryKey: igamingNgrGgrQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingNgrGgrCreate(): UseMutationResult<IgamingNgrGgrRow, Error, CreateIgamingNgrGgrBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNgrGgrQueryKeys.all });
		},
	});
}

export function useIgamingNgrGgrDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNgrGgrQueryKeys.all });
		},
	});
}
